import styled from 'styled-components'
import { color } from 'shared/utils/styles';

export default styled.div`
  padding-bottom: 20px;
  border-top: 1px solid ${color.borderDark};
`;